export const module = {
  info: {
    name: 'system-role',
    caption: 'System Role',
    viewGroup: 'users'
  },
  vuexModules: ['api', 'state'],
  mainRoute: '/cpanel'
}

export default module